import { NEWSLETTER_PAGE_LINK } from "@components/Newsletter/constants";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NewsletterContributor, {
  NewsletterContributorProps,
} from "@routes/Newsletter/Archive/components/NewsletterContributor";

export type NewsletterArchiveHeaderProps = {
  newsletterDescription?: string;
  newsletterContributors?: NewsletterContributorProps[];
  newsletterTitle: string;
};

export default function NewsletterArchiveHeader({
  newsletterDescription,
  newsletterContributors = [],
  newsletterTitle,
}: NewsletterArchiveHeaderProps): React.ReactElement {
  return (
    <div>
      <div className="pb-6 font-medium">
        <a
          className="font-poppins text-base text-gray-850 no-underline"
          href={NEWSLETTER_PAGE_LINK}
        >
          <FontAwesomeIcon
            icon={faChevronLeft}
            size="xs"
            width={15}
            height={12}
            className="pr-2"
          />
          All newsletters
        </a>
      </div>

      <p className="mb-2 font-lct text-10xl font-bold !leading-[43px] text-gray-850 lg:text-[3.25rem] lg:!leading-[62px]">
        {newsletterTitle}
      </p>

      <p className="mb-0 font-public-sans text-lg font-normal text-gray-850 lg:text-base">
        {newsletterDescription}
      </p>

      <div className="pt-14">
        {newsletterContributors.map((contributor, index) => (
          <NewsletterContributor
            key={index}
            imageSrc={contributor.imageSrc}
            quote={contributor.quote}
            name={contributor.name}
          />
        ))}
      </div>
    </div>
  );
}
